try {
  (() => {
    if (Promise.allSettled) {
      return;
    }
    Promise.allSettled = (promises) =>
      Promise.all(
        promises.map((p) =>
          p
            .then((value) => ({
              status: 'fulfilled',
              value,
            }))
            .catch((reason) => ({
              status: 'rejected',
              reason,
            })),
        ),
      );
  })();
  console.log('[Polyfills] Promise.allSettled polyfill added.');
} catch (err) {
  console.error('[Polyfills] Unable to polyfill Promise.allSettled', err);
}
